import React from "react";
import "../styles/Input-Radio.scss";

const InputRadioButton = (props) => {
  
  if(props.active === true && props.options.length) {  
    let checked = props.show ? "Yes" : "No";
    return(
      <>
        <div className="input-radio">
          <div className="text-center">
            {props.question}
          </div>
          <div className="radio-buttons-wrapper">
            { 
            props.options.map((option, i) => (
              <span key={i}>
              <input 
                  type="radio" 
                  id={props.id} 
                  name={props.id}
                  value={option}
                  onChange={props.changed}
                  checked = {option===checked?'checked':''}
                />
                <label htmlFor={props.id}>{option}</label>        
              </span>  
            ))
            }
          </div>
        </div>
      </>
    )
  } else {
    return (<></>);
  }
};

export default InputRadioButton;
